import type { PickupAssignmentDriverGroup } from "../hooks/usePickupAssignmentDriversColumn";

export type DriverWorkloadTotals = {
  deliveriesCompleted: number;
  numberOfDeliveries: number;
  pickupsCompleted: number;
  numberOfPickups: number;
};

export function aggregateDriverWorkload(
  drivers: PickupAssignmentDriverGroup[]
): DriverWorkloadTotals {
  return drivers.reduce(
    (acc, d) => ({
      deliveriesCompleted: acc.deliveriesCompleted + d.deliveriesCompleted,
      numberOfDeliveries: acc.numberOfDeliveries + d.numberOfDeliveries,
      pickupsCompleted: acc.pickupsCompleted + d.pickupsCompleted,
      numberOfPickups: acc.numberOfPickups + d.numberOfPickups,
    }),
    {
      deliveriesCompleted: 0,
      numberOfDeliveries: 0,
      pickupsCompleted: 0,
      numberOfPickups: 0,
    }
  );
}
